import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
const mergeLocaleMessage = (localeMessages) => {
  const messages = {}

  localeMessages.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = localeMessages(key)
    }
  })

  return messages
}

function loadLocaleMessages () {
  let locales = require.context('./modules/external-user-service/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const externalUserMessages = mergeLocaleMessage(locales)
  locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const defaultMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/portal/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const portalMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/auth-service/auth/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const authMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/auth-service/user-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const userManagementMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/org-profile/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const orgProfileMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/organogram/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const organogramMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/complain/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const complainMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/notification/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const notificationMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/api-manager/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const apiManagerMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/payment-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const paymentManagementMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/document/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const documentMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/info-service-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const infoServiceMgmtMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/committee/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const committeeMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/data-archive/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const dataArchiveMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/production-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const productionConfigurationMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/hospital-disability-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const hospitalConfigMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/child-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const childConfigMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/child-service/institute-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const childInstituteManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/child-service/legal-institute-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const childLegalInstituteManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/child-service/rehabilitation-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const childrehabilitationManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/production-service/store-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const productionStoreManageMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/hospital-disability-service/information/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const hospitalInfoMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/child-service/child-admission-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const childAddmissionManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/child-service/educational-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const childEducationalManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/child-service/reports/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const childReports = mergeLocaleMessage(locales)
  locales = require.context('./modules/production-service/retailer-dealer-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const productionRetailerDealerMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/production-service/sales-distribution-admin/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const salesDistributionAdminMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/production-service/sales-center/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const salesCenterMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/hospital-disability-service/store-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const hospitalStoreManagementService = mergeLocaleMessage(locales)
  locales = require.context('./modules/hospital-disability-service/consultancy-therapy-center/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const thirtyPercentStoreManagementService = mergeLocaleMessage(locales)
  locales = require.context('./modules/hospital-disability-service/thirty-percent/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const hospitalConsultancyService = mergeLocaleMessage(locales)
  locales = require.context('./modules/production-service/promotion-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const productionPromotionManagementMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/hospital-disability-service/public-panel/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const hospitalPublicPanel = mergeLocaleMessage(locales)
  locales = require.context('./modules/hospital-disability-service/billing-information-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const hospitalInformationManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/hospital-disability-service/social-service/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const hospitalSocialServiceMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/grant-allowance-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const grantAllowanceConfigurationMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/grant-allowance-service/budget-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const grantAllowanceBudgetManagementMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/grant-allowance-service/process/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const grantAllowanceProcessMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/grant-allowance-service/registration-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const grantAllowanceRegistrationMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/grant-allowance-service/payment-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const grantAllowancePaymentMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/grant-allowance-service/performance-monitoring/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const grantAllowancePerformanceMonitorMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/grant-allowance-service/citizen-card/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const grantAllowanceCitizenCardMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/grant-allowance-service/social-organization/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const grantAllowanceSocialOrganizationMessages = mergeLocaleMessage(locales)
  locales = require.context('./modules/common-config/portal/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const agriPortalLocale = mergeLocaleMessage(locales)
  /** Awareness Event */
  locales = require.context('./modules/awareness-event-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const awarenessEventConfig = mergeLocaleMessage(locales)
  locales = require.context('./modules/awareness-event-service/event-management-system/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const awarenessEventManagementSystem = mergeLocaleMessage(locales)
  locales = require.context('./modules/awareness-event-service/info-management-system/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const awarenessEventInfoManagementSystem = mergeLocaleMessage(locales)
  locales = require.context('./modules/awareness-event-service/job-fair-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const awarenessEventJobFairManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/awareness-event-service/assistive-device-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const awarenessAssistiveDeviceManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/awareness-event-service/assistive-device-delivery-and-distribution-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const assistiveDeviceDeliveryAndDistributionManagement = mergeLocaleMessage(locales)
  /** Disability School */
  locales = require.context('./modules/disability-school-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const disabilitySchoolConfiguration = mergeLocaleMessage(locales)
  locales = require.context('./modules/disability-school-service/institute-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const disabilitySchoolInstitute = mergeLocaleMessage(locales)
  locales = require.context('./modules/disability-school-service/student-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const disabilitySchoolStudent = mergeLocaleMessage(locales)
  locales = require.context('./modules/disability-school-service/admission-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const disabilitySchoolAdmission = mergeLocaleMessage(locales)
  locales = require.context('./modules/disability-school-service/exam-result-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const disabilitySchoolExamAndResult = mergeLocaleMessage(locales)
  locales = require.context('./modules/disability-school-service/report/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const disabilitySchoolReport = mergeLocaleMessage(locales)

  // Training Learning Service
  locales = require.context('./modules/training-e-learning-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const trainingElearningConfiguration = mergeLocaleMessage(locales)
  locales = require.context('./modules/training-e-learning-service/report-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const trainingElearningReportManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/training-e-learning-service/information-application-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const trainingElearninginformationApplicationManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/training-e-learning-service/training-plan-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const trainingElearningTrainingPlanManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/training-e-learning-service/trainer-trainee-info-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
   const trainingElearningTrainerTraineeInfoManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/training-e-learning-service/accommodation-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const trainingElearningTrainerTraineeAccommodationManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/social-welfare-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const socialWelfareConfiguration = mergeLocaleMessage(locales)
  locales = require.context('./modules/social-welfare-service/manual-content-management/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const socialWelfareManualContentManagement = mergeLocaleMessage(locales)
  locales = require.context('./modules/street-children-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const stretChildreenConfiguration = mergeLocaleMessage(locales)
  locales = require.context('./modules/street-children-service/street-children/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const stretChildreenMain = mergeLocaleMessage(locales)
  locales = require.context('./modules/street-children-service/report/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const stretChildreenReport = mergeLocaleMessage(locales)
  locales = require.context('./modules/rehabilitation-vagrant-service/configuration/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const rehabilitationVagrantConfiguration = mergeLocaleMessage(locales)
  locales = require.context('./modules/rehabilitation-vagrant-service/vagrant/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const rehabilitationVagrantMain = mergeLocaleMessage(locales)
  locales = require.context('./modules/rehabilitation-vagrant-service/report/locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const rehabilitationVagrantReport = mergeLocaleMessage(locales)
  const allMessages = {
    bn: Object.assign(
      {},
      defaultMessages.bn,
      portalMessages.bn,
      externalUserMessages.bn,
      authMessages.bn,
      userManagementMessages.bn,
      orgProfileMessages.bn,
      apiManagerMessages.bn,
      organogramMessages.bn,
      complainMessages.bn,
      notificationMessages.bn,
      documentMessages.bn,
      infoServiceMgmtMessages.bn,
      committeeMessages.bn,
      dataArchiveMessages.bn,
      agriPortalLocale.bn,
      paymentManagementMessages.bn,
      productionConfigurationMessages.bn,
      hospitalConfigMessages.bn,
      childConfigMessages.bn,
      childInstituteManagement.bn,
      childLegalInstituteManagement.bn,
      childrehabilitationManagement.bn,
      productionStoreManageMessages.bn,
      hospitalInfoMessages.bn,
      childAddmissionManagement.bn,
      childEducationalManagement.bn,
      childReports.bn,
      productionRetailerDealerMessages.bn,
      salesDistributionAdminMessages.bn,
      salesCenterMessages.bn,
      hospitalSocialServiceMessages.bn,
      hospitalStoreManagementService.bn,
      thirtyPercentStoreManagementService.bn,
      hospitalConsultancyService.bn,
      productionPromotionManagementMessages.bn,
      hospitalPublicPanel.bn,
      hospitalInformationManagement.bn,
      grantAllowanceConfigurationMessages.bn,
      grantAllowanceBudgetManagementMessages.bn,
      grantAllowanceProcessMessages.bn,
      grantAllowanceRegistrationMessages.bn,
      grantAllowancePaymentMessages.bn,
      grantAllowancePerformanceMonitorMessages.bn,
      grantAllowanceCitizenCardMessages.bn,
      grantAllowanceSocialOrganizationMessages.bn,
      awarenessEventConfig.bn,
      disabilitySchoolConfiguration.bn,
      disabilitySchoolInstitute.bn,
      disabilitySchoolStudent.bn,
      disabilitySchoolAdmission.bn,
      disabilitySchoolExamAndResult.bn,
      awarenessEventManagementSystem.bn,
      awarenessEventInfoManagementSystem.bn,
      awarenessEventJobFairManagement.bn,
      awarenessAssistiveDeviceManagement.bn,
      assistiveDeviceDeliveryAndDistributionManagement.bn,
      disabilitySchoolReport.bn,
      trainingElearningConfiguration.bn,
      trainingElearningReportManagement.bn,
      trainingElearninginformationApplicationManagement.bn,
      trainingElearningTrainingPlanManagement.bn,
      trainingElearningTrainerTraineeInfoManagement.bn,
      trainingElearningTrainerTraineeAccommodationManagement.bn,
      socialWelfareConfiguration.bn,
      stretChildreenConfiguration.bn,
      stretChildreenMain.bn,
      stretChildreenReport.bn,
      rehabilitationVagrantConfiguration.bn,
      rehabilitationVagrantMain.bn,
      rehabilitationVagrantReport.bn,
      socialWelfareManualContentManagement.bn
    ),
    en: Object.assign(
      {},
      defaultMessages.en,
      portalMessages.en,
      externalUserMessages.en,
      authMessages.en,
      userManagementMessages.en,
      orgProfileMessages.en,
      apiManagerMessages.en,
      organogramMessages.en,
      complainMessages.en,
      notificationMessages.en,
      documentMessages.en,
      infoServiceMgmtMessages.en,
      committeeMessages.en,
      dataArchiveMessages.en,
      agriPortalLocale.en,
      paymentManagementMessages.en,
      productionConfigurationMessages.en,
      hospitalConfigMessages.en,
      childConfigMessages.en,
      childInstituteManagement.en,
      childLegalInstituteManagement.en,
      childrehabilitationManagement.en,
      productionStoreManageMessages.en,
      hospitalInfoMessages.en,
      childAddmissionManagement.en,
      childEducationalManagement.en,
      childReports.en,
      productionRetailerDealerMessages.en,
      salesDistributionAdminMessages.en,
      salesCenterMessages.en,
      hospitalSocialServiceMessages.en,
      hospitalStoreManagementService.en,
      thirtyPercentStoreManagementService.en,
      hospitalConsultancyService.en,
      productionPromotionManagementMessages.en,
      hospitalPublicPanel.en,
      hospitalInformationManagement.en,
      grantAllowanceConfigurationMessages.en,
      grantAllowanceBudgetManagementMessages.en,
      grantAllowanceProcessMessages.en,
      grantAllowanceRegistrationMessages.en,
      grantAllowancePaymentMessages.en,
      grantAllowancePerformanceMonitorMessages.en,
      grantAllowanceCitizenCardMessages.en,
      grantAllowanceSocialOrganizationMessages.en,
      awarenessEventConfig.en,
      disabilitySchoolConfiguration.en,
      disabilitySchoolInstitute.en,
      disabilitySchoolStudent.en,
      disabilitySchoolAdmission.en,
      disabilitySchoolExamAndResult.en,
      awarenessEventManagementSystem.en,
      awarenessEventInfoManagementSystem.en,
      awarenessEventJobFairManagement.en,
      awarenessAssistiveDeviceManagement.en,
      assistiveDeviceDeliveryAndDistributionManagement.en,
      disabilitySchoolReport.en,
      trainingElearningConfiguration.en,
      trainingElearningReportManagement.en,
      trainingElearninginformationApplicationManagement.en,
      trainingElearningTrainingPlanManagement.en,
      trainingElearningTrainerTraineeInfoManagement.en,
      trainingElearningTrainerTraineeAccommodationManagement.en,
      socialWelfareConfiguration.en,
      stretChildreenConfiguration.en,
      stretChildreenMain.en,
      stretChildreenReport.en,
      rehabilitationVagrantConfiguration.en,
      rehabilitationVagrantMain.en,
      rehabilitationVagrantReport.en,
      socialWelfareManualContentManagement.en
    )
  }
  return allMessages
}

export default new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})
